import { isNotSet } from '@/utils/formatChecker';

export const searchParamParser = <P>(param: P | Array<P> | undefined): undefined | Array<P> =>
  isNotSet(param) ? undefined : Array.isArray(param) ? param : [param];
